import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const GA_TRACKING_ID = 'G-YEZ8NV5P8F';
const TIKTOK_PIXEL_ID = 'CVFK893C77U26P8I7UMG';

declare global {
  interface Window {
    ttq: any;
    gtag: (...args: any[]) => void;
    dataLayer: any[];
  }
}

export default function Analytics() {
  const location = useLocation();

  useEffect(() => {
    let isSubscribed = true;

    // Google Analytics Setup
    const loadGoogleAnalytics = () => {
      if (!isSubscribed) return;

      const script = document.createElement('script');
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_TRACKING_ID}`;
      
      script.onload = () => {
        if (!isSubscribed) return;

        window.dataLayer = window.dataLayer || [];
        function gtag(...args: any[]) {
          window.dataLayer.push(args);
        }
        window.gtag = gtag;

        gtag('js', new Date());
        gtag('config', GA_TRACKING_ID, {
          page_path: location.pathname + location.search,
          send_page_view: true
        });
      };

      document.head.appendChild(script);
    };

    // TikTok Pixel Setup
    const loadTikTokPixel = () => {
      if (!isSubscribed) return;

      // Initialize TikTok's ttq object
      window.ttq = window.ttq || [];

      const script = document.createElement('script');
      script.async = true;
      script.src = `https://analytics.tiktok.com/i18n/pixel/events.js?sdkid=${TIKTOK_PIXEL_ID}`;
      
      script.onload = () => {
        if (!isSubscribed || !window.ttq) return;
        
        // Only call these methods if they exist
        if (typeof window.ttq.load === 'function') {
          window.ttq.load(TIKTOK_PIXEL_ID);
        }
        if (typeof window.ttq.page === 'function') {
          window.ttq.page();
        }
      };

      document.head.appendChild(script);
    };

    // Track page views
    const trackPageView = () => {
      if (!isSubscribed) return;

      // Google Analytics
      if (window.gtag) {
        window.gtag('event', 'page_view', {
          page_title: document.title,
          page_location: window.location.href,
          page_path: location.pathname + location.search
        });
      }

      // TikTok
      if (window.ttq && typeof window.ttq.page === 'function') {
        window.ttq.page();
      }
    };

    // Initialize analytics
    loadGoogleAnalytics();
    loadTikTokPixel();

    // Track initial page view
    const timeoutId = setTimeout(trackPageView, 1000);

    // Cleanup function
    return () => {
      isSubscribed = false;
      clearTimeout(timeoutId);
    };
  }, [location]);

  return null;
}